import React from 'react';
import { Modal, Table, Button, Badge } from 'react-bootstrap';
 
const SendStatusModal = ({
  show,
  onHide,
  onSend,
  summary = {},
  openLocation,
  openStatus,
  openGroups,
  openMessage,
}) => {
  const {
    fullName,
    location,
    statusArr = [],
    groupsArr = [],
    messageText,
    attachment,                   // may be null or {type,url}
  } = summary;

  /* badge helper */
  const makeBadge = (v, variant = 'secondary', txt = 'light') => (
    <Badge key={v} bg={variant} text={txt} className="me-1 mb-1" style={{ fontSize: 12 }}>
      {v}
    </Badge>
  );

  /* convenience row builder */
  const row = ({ btnText, variant, handler, content }) => (
    <tr>
      <td style={{ width: '35%' }}>
        <Button
          size="sm"
          variant={variant}
          className="w-100 text-white"
          onClick={() => handler?.()}
        >
          {btnText}
        </Button>
      </td>
      <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{content}</td>
    </tr>
  );

  return (
    <Modal show={show} onHide={onHide} centered size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">Send My Status</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="table-responsive">
          <Table size="sm" bordered className="w-100 mb-0">
            <tbody>
              {/* name row */}
              <tr>
                <td className="fw-semibold" style={{ width: '35%' }}>
                  Name
                </td>
                <td>{fullName || '—'}</td>
              </tr>

              {/* location */}
              {row({
                btnText : 'Incident Location',
                variant : 'dark',
                handler : openLocation,
                content : location || '—',
              })}

              {/* my status */}
              {row({
                btnText : 'My Status',
                variant : 'warning',
                handler : openStatus,
                content : statusArr.length
                  ? statusArr.map(s => makeBadge(s, 'warning', 'dark'))
                  : makeBadge('No status', 'secondary'),
              })}

              {/* groups */}
              {row({
                btnText : 'Groups',
                variant : 'primary',
                handler : openGroups,
                content : groupsArr.length
                  ? groupsArr.map(g => makeBadge(g, 'primary'))
                  : '—',
              })}

              {/* message / attachment */}
              {row({
                btnText : 'Message / Photo',
                variant : 'info',
                handler : openMessage,
                content : (
                  <>
                    {messageText || '—'}
                    {attachment && (
                      <>
                        <br/>
                        <Badge bg="info" className="mt-1">
                          {attachment.type}
                        </Badge>
                      </>
                    )}
                  </>
                ),
              })}
            </tbody>
          </Table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSend}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendStatusModal;


